import { createTelemetryAPI } from '~/utils/telemetry'

export const loginTelemetry = createTelemetryAPI(({ track }) => ({
  clickSignIn(oauth_type: string) {
    return track('Login: Click Sign In', { oauth_type })
  },
  clickInfo(
    type:
      | 'introduction'
      | 'quick_start'
      | 'release_note'
      | 'services-agreement'
      | 'privacy'
      | 'contact_us'
  ) {
    return track('Login: Click Information About Clinic', { type })
  }
}))
